import { EXPANDED_NAV_LS_KEY } from '@/constants/nav';
import { EventBus } from '@utils/event-bus.js';

const leftNav = {
    namespaced: true,
    state: {
        expanded: true,
        isTopBannerDismissed: false,
        isBlurred: false,
        topBannerHeight: 0,
    },
    mutations: {
        setExpanded (state, { expanded }) {
            state.expanded = expanded;
        },
        setTopBannerDismissed (state, { isTopBannerDismissed }) {
            state.isTopBannerDismissed = isTopBannerDismissed;
        },
        setBlurred (state, { isBlurred }) {
            state.isBlurred = isBlurred;
        },
        setTopBannerHeight (state, { topBannerHeight }) {
            state.topBannerHeight = topBannerHeight;
        },
    },
    actions: {
        expandCollapseNav ({ commit }, { expanded }) {
            commit('setExpanded', { expanded });
            window.localStorage.setItem(EXPANDED_NAV_LS_KEY, expanded);
            EventBus.$emit('sideNavExpandedStateChanged');
        },
    },
    getters: {},
};

export default leftNav;
